import React, { useState, useEffect } from "react";
import Papa from "papaparse";
import Header from "./Header";
import Footer from "./Footer";
import "./ShipMaintenanceTable.css";

const ShipMaintenanceTable = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filter, setFilter] = useState("default");

  useEffect(() => {
    // Load the CSV file
    const fetchData = async () => {
      const response = await fetch("/predictions.csv"); // Adjust the path if necessary
      const reader = await response.text();
      Papa.parse(reader, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          // Extract relevant columns
          const parsedData = results.data.map((row) => ({
            imoNo: row["IMO NO"],
            vesselName: row["VESSEL NAME"].toUpperCase(), // Capitalize vessel names
            nextMaintenanceDate: new Date(row["NEXT MAINTENANCE DATE"]),
          }));

          // Sort data by default (latest maintenance on top)
          parsedData.sort(
            (a, b) => b.nextMaintenanceDate - a.nextMaintenanceDate
          );

          setData(parsedData);
          setFilteredData(parsedData); // Set initial filtered data
        },
      });
    };

    fetchData();
  }, []);

  const handleFilterChange = (e) => {
    const filterValue = e.target.value;
    setFilter(filterValue);

    if (filterValue === "ascending") {
      const sortedData = [...data].sort(
        (a, b) => a.nextMaintenanceDate - b.nextMaintenanceDate
      );
      setFilteredData(sortedData);
    } else if (filterValue === "descending") {
      const sortedData = [...data].sort(
        (a, b) => b.nextMaintenanceDate - a.nextMaintenanceDate
      );
      setFilteredData(sortedData);
    } else if (filterValue === "upcoming-week") {
      const now = new Date();
      const oneWeekFromNow = new Date();
      oneWeekFromNow.setDate(now.getDate() + 7);

      const upcomingWeekData = data.filter(
        (row) =>
          row.nextMaintenanceDate >= now &&
          row.nextMaintenanceDate <= oneWeekFromNow
      );
      const sortedData = [...upcomingWeekData].sort(
        (a, b) => a.nextMaintenanceDate - b.nextMaintenanceDate
      );
      setFilteredData(sortedData);
    } else if (filterValue === "upcoming-month") {
      const now = new Date();
      const oneMonthFromNow = new Date();
      oneMonthFromNow.setDate(now.getDate() + 30);

      const upcomingMonthData = data.filter(
        (row) =>
          row.nextMaintenanceDate >= now &&
          row.nextMaintenanceDate <= oneMonthFromNow
      );
      const sortedData = [...upcomingMonthData].sort(
        (a, b) => a.nextMaintenanceDate - b.nextMaintenanceDate
      );
      setFilteredData(sortedData);
    } else if (filterValue === "upcoming-year") {
      const now = new Date();
      const oneYearFromNow = new Date();
      oneYearFromNow.setFullYear(now.getFullYear() + 1);

      const upcomingYearData = data.filter(
        (row) =>
          row.nextMaintenanceDate >= now &&
          row.nextMaintenanceDate <= oneYearFromNow
      );
      const sortedData = [...upcomingYearData].sort(
        (a, b) => a.nextMaintenanceDate - b.nextMaintenanceDate
      );
      setFilteredData(sortedData);
    } else {
      setFilteredData(data); // Reset to default data
    }
  };

  // Helper function to format date as YYYY-MM-DD
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Add leading zero for single-digit months
    const day = String(date.getDate()).padStart(2, "0"); // Add leading zero for single-digit days
    return `${year}-${month}-${day}`;
  };

  return (
    <div className="app-container">
      <Header />

      <main className="content">
        <div className="maintenance-table">
          <div className="header">
            <h1>Predicted Ship Maintenance</h1>
            <div className="filter-container">
              <label htmlFor="filter">Sort/Filter: </label>
              <select
                id="filter"
                value={filter}
                onChange={handleFilterChange}
                className="filter-select"
              >
                <option value="default">Default (All)</option>
                <option value="ascending">Reverse (All)</option>
                {/* <option value="descending">Descending (Latest First)</option> */}
                <option value="upcoming-week">Upcoming Week</option>
                <option value="upcoming-month">Upcoming Month</option>
                <option value="upcoming-year">Upcoming Year</option>
              </select>
            </div>
          </div>
          {filteredData.length === 0 ? (
            <p className="no-records">No maintenance records found.</p>
          ) : (
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>IMO NO</th>
                    <th>Vessel Name</th>
                    <th>Next Maintenance Date</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((row, index) => (
                    <tr key={index}>
                      <td className="imo-no center" data-label="IMO NO">
                        {parseInt(row.imoNo, 10)}
                      </td>
                      <td className="vessel-name" data-label="Vessel Name">
                        {row.vesselName}
                      </td>
                      <td
                        className="next-maintenance center"
                        data-label="Next Maintenance Date"
                      >
                        {formatDate(row.nextMaintenanceDate)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>

  );
};

export default ShipMaintenanceTable;